// extracted by mini-css-extract-plugin
export default {"tooltipContainer":"y_umMm"};